import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "LessThan.svg",
  "use": "LessThan.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"LessThan.svg\"><path clip-rule=\"evenodd\" d=\"m17.8458 7.69243c-.1698-.46713-.6862-.70811-1.1533-.53824l-11.00004 4.00001c-.35568.1293-.59244.4673-.59244.8458s.23676.7165.59244.8458l11.00004 4c.4671.1699.9835-.0711 1.1533-.5382.1699-.4672-.0711-.9835-.5382-1.1534l-8.67402-3.1542 8.67402-3.15419c.4671-.16986.7081-.68625.5382-1.15338z\" fill=\"#101820\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol